

<spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">

     <div header>
        <spike-equipment-request-filters-form [(searchFilter)]="searchFilter"></spike-equipment-request-filters-form>
    </div>

    <div>
        @if(entityList.hasValue() && entityList.value().list.length>0){
            <div>
                <div class="mb-2" style="font-weight: bold;">Risultati: {{entityList.value().totalCount}}</div>
                <div class="spike-table-card">
                    <spike-equipment-requests-table 
                    [minimal]="false" 
                    [items]="entityList.value().list" 
                    (onSelect)="onSelect($event)"
                    [(sorting)]="sorting">
                </spike-equipment-requests-table>
                </div>
            </div>
            @if(entityList.value().totalCount> 25){
            <div>
                <p-paginator (onPageChange)="onPageChange($event)" [first]="pagination().first" [rows]="pagination().rows" [totalRecords]="entityList.value().totalCount" [rowsPerPageOptions]="this.pagination().rowsPerPageOptions" />
            </div>
            }
        }
        @else {
            <spike-no-result></spike-no-result>
        }
        
    </div>
</spike-base-page>

@if(isDialogVisible()){
    <spike-equipment-request-side-panel 
        [dataId]="selectedItem()!" 
        [(isDialogVisible)]="isDialogVisible" 
        (onClose)="isDialogVisible.set(false)"
        (onSave)="onSave()">
    </spike-equipment-request-side-panel>
}